import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useRequirementStore = defineStore('requirement', () => {
    const all = ref({ data: [] });

    const reset = () => {
        all.value = { data: [] };
    };

    const search = (params) => {
        return axios.get('/api/v1/requirements', { params });
    };

    const store = (params) => {
        return axios.post('/api/v1/requirements', params);
    };

    const update = (params) => {
        return axios.patch('/api/v1/requirements/' + params.hash, params);
    };

    return {
        all,
        reset,
        search,
        store,
        update,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useRequirementStore, import.meta.hot));
}
